<template>
  <!-- Content Wrapper-->
  <div class="content-wrapper">
    <!-- Content Header -->
    <div class="content-header">
      <div
        class="d-flex align-items-center"
        style="border-bottom: 1px solid #00000017"
      >
        <div class="row">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">Main Dashboard</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <li class="breadcrumb-item active">All Websites</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <section class="content d-flex justify-content-center">
      <!-- Container -->
      <div class="container">
        <div class="d-flex align-items-center justify-items-center">
          <v-text-field
            v-if="domains.length || !loading"
            label="Search by domain or description"
            class="p-0 m-0 mr-6"
            append-icon="mdi-magnify"
            height="40"
            style="height: 79px !important"
            full-width
            v-model="search"
            data-qa-node="domain_search"
          ></v-text-field>
          <!-- Tags filter -->
          <v-combobox
            v-if="domains.length || !loading"
            class="p-0 m-0"
            v-model="selectedTagsForSearching"
            data-qa-node="tags_filter"
            label="Filter By Tags"
            :light="true"
            :items="tags"
            clearable
            multiple
            item-text="name"
            item-value="id"
            chips
            deletable-chips
            full-width
            :class="{ 'd-none': isUserRole }"
            style="width: 30%"
          >
          </v-combobox>
        </div>
        <!-- <transition-group
          tag="div"
          class="row card_group"
          enter-active-class="animate__animated animate__zoomIn animate__faster"
          leave-active-class="animate__animated animate__zoomOut animate__faster"
        > -->
        <v-data-table
          :items="filteredDomains"
          :items-per-page="20"
          :hide-default-footer="!domains.length"
          :footer-props="{
            'items-per-page-options': [20, 50, 100],
          }"
        >
          <!-- Domains -->
          <template #body="{ items }">
            <tbody class="l-flex-domains">
              <transition-group
                tag="div"
                class="row my-1"
                enter-active-class="animate__animated animate__zoomIn animate__faster"
                leave-active-class="animate__animated animate__zoomOut animate__faster"
              >
                <!-- Card For Adding New Website -->
                <div
                  class="col-xl-4 col-md-6 pt-1"
                  :key="0"
                  v-if="
                    (domains.length || (!loading && !domains.length)) &&
                    !isUserRole
                  "
                  @click="shwAddNewDmnPopUp = true"
                >
                  <div class="add-new-website-card">
                    <div class="add-new-website-card-body">
                      <span
                        class="add-new-website-card-plus"
                        style="cursor: pointer"
                        >&plus;</span
                      >
                      <h5
                        class="add-new-website-card-title"
                        style="cursor: pointer"
                      >
                        Add New Website
                      </h5>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-4 col-md-6 pt-1"
                  v-for="item in items"
                  :key="item.id"
                  :id="item.id"
                >
                  <div
                    :ref="item.url"
                    class="card"
                    :to="{ name: 'MainCont', params: { id: item.id } }"
                  >
                    <div class="card-header">
                      <div
                        class="d-flex align-items-center"
                        style="max-width: 70%"
                      >
                        <span
                          class="card-indicator"
                          :class="[
                            !!item['is_active']
                              ? 'active-card-indicator'
                              : 'inactive-card-indicator',
                          ]"
                        ></span>
                        <small class="mr-1" style="font-size: 15px !important;">{{ item.id }}</small>
                        <router-link
                          class="card-header-label height-21"
                          style="cursor: pointer; color: #000000de"
                          :to="{ name: 'MainCont', params: { id: item.id } }"
                        >
                          {{ item.url.split("://")[1] || item.url }}
                        </router-link>
                      </div>
                      <div class="card-btn-group" v-if="!isUserRole">
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          @click="
                            shwChangeDmnName = true;
                            domainNameToChange = item.url;
                            dmn_id = item.id;
                          "
                        >
                          <path
                            d="M2.0835 14.25H3.00016L12.2293 5.02082L11.3127 4.10416L2.0835 13.3333V14.25ZM14.8752 4.12499L12.2085 1.45832L13.0835 0.583323C13.3196 0.347212 13.6113 0.229156 13.9585 0.229156C14.3057 0.229156 14.5974 0.347212 14.8335 0.583323L15.7502 1.49999C15.9863 1.7361 16.1043 2.02777 16.1043 2.37499C16.1043 2.72221 15.9863 3.01388 15.7502 3.24999L14.8752 4.12499ZM14.0002 4.99999L3.50016 15.5H0.833496V12.8333L11.3335 2.33332L14.0002 4.99999ZM11.771 4.56249L11.3127 4.10416L12.2293 5.02082L11.771 4.56249Z"
                            fill="#3579F5"
                          />
                        </svg>
                        <svg
                          @click="openWarningPopUp($event)"
                          width="17"
                          height="18"
                          viewBox="0 0 17 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.60425 17.0208C3.04869 17.0208 2.57994 16.8333 2.198 16.4583C1.81605 16.0833 1.62508 15.6181 1.62508 15.0625V3.54168H0.416748V1.58334H5.22925V0.583344H11.4167V1.58334H16.2501V3.54168H15.0417V15.0625C15.0417 15.6042 14.8473 16.066 14.4584 16.4479C14.0695 16.8299 13.6042 17.0208 13.0626 17.0208H3.60425ZM13.0626 3.54168H3.60425V15.0625H13.0626V3.54168ZM5.70842 13.4375H7.31258V5.12501H5.70842V13.4375ZM9.35425 13.4375H10.9792V5.12501H9.35425V13.4375ZM3.60425 3.54168V15.0625V3.54168Z"
                            fill="#E45B54"
                          />
                        </svg>
                      </div>
                    </div>
                    <div class="card-body">
                      <router-link
                        class="card-img"
                        style="cursor: pointer"
                        :style="{
                          'background-image': item.default_icon
                            ? 'url(' + item.default_icon + ')'
                            : 'url(' + websiteDefaultImage + ')',
                        }"
                        :to="{ name: 'MainCont', params: { id: item.id } }"
                      ></router-link>
                      <div
                        style="height: 40px"
                        class="text-left overflow-auto my-3"
                        v-if="!isUserRole"
                      >
                        <v-chip
                          class="mr-1 ma-2 lighten-4"
                          v-for="(tag, i) in item.domain_tags"
                          :key="i"
                          small
                          close
                          close-icon="mdi-close"
                          @click="selectedTagsForSearching.push(tag)"
                          :class="{
                            purple: tag.type
                              ? tag.type.includes('server')
                              : false,
                            'deep-orange': tag.type
                              ? tag.type.includes('category')
                              : false,
                            blue: tag.type ? tag.type.includes('adult') : false,
                            red: tag.type ? tag.type.includes('geo') : false,
                          }"
                          @click:close="
                            (selectedTagsWebsiteId = item.website_id),
                              (tagName = tag.name),
                              (shwTagsQuestion = true)
                          "
                          >{{ tag.name }}</v-chip
                        >
                        <!-- Add Tag Button -->
                        <v-menu transition="scroll-y-transition">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="secondary"
                              x-small
                              plain
                              text
                              v-bind="attrs"
                              v-on="on"
                              class="text-capitalize caption font-weight-medium"
                            >
                              <v-icon dark class="caption"> mdi-plus </v-icon>
                              Add tag
                            </v-btn>
                          </template>
                          <v-list>
                            <v-text-field
                              v-model="searchTag"
                              label="Search tag"
                              single-line
                              hide-details
                              class="p-2"
                            ></v-text-field>
                            <v-list-item
                              v-for="tag in filteredTags"
                              :key="tag.id"
                              link
                              @click="
                                bindTagToDomain(
                                  item.url,
                                  item.website_id,
                                  tag.name,
                                  tag.type
                                )
                              "
                            >
                              <v-list-item-title>{{
                                tag.name
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                      <!-- Card Description -->
                      <div
                        v-if="!isUserRole"
                        class="card-description"
                        @keyup.enter="
                          $event.stopImmediatePropagation();
                          updateDomainDescription(item.id, domain);
                        "
                      >
                        <v-text-field
                          class="p-0 text-center"
                          label="Add note"
                          :full-width="true"
                          :append-icon="
                            item.description
                              ? 'mdi-pencil-outline'
                              : 'mdi-arrow-up'
                          "
                          @blur="
                            $event.stopImmediatePropagation();
                            updateDomainDescription(item.id, item);
                          "
                          v-model="item.description"
                          rounded
                          dense
                          style="height: 48px !important"
                          >{{ item.description }}</v-text-field
                        >
                      </div>
                      <!-- Tags Loading -->
                      <div
                        class="spinner-border text-primary"
                        style="
                          display: none;
                          font-size: 5px;
                          width: 20px;
                          height: 20px;
                          position: absolute;
                          top: 50%;
                          left: 50%;
                        "
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </tbody>
          </template>
        </v-data-table>
        <!-- </transition-group> -->
        <!-- Error -->
        <Error v-if="error" :error="error" />
        <!-- Loading Spinner -->
        <div
          class="d-flex justify-content-center align-items-center spinner-block"
          style="height: calc(100vh - 210px)"
          v-if="loading"
        >
          <BSpinner variant="primary" label="Large Spinner" />
        </div>
      </div>
      <Question
        v-if="shwQuestion"
        @didClose="shwQuestion = false"
        @confirmed="deleteDomain"
        @notConfirmed="shwQuestion = false"
        title="Are you sure?"
        text="You will delete this domain and won't be able to restore it."
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        isConfirmedTitle="Deleted!"
        isConfirmedText="Your domain has been deleted!"
        dismissTitle="Cancelled!"
        dismissText="Your domain is in the safe :)"
        confirmButtonClasses="btn btn-success"
        cancelButtonClasses="btn btn-danger"
        successIcon="success"
        errorIcon="error"
      />
      <Question
        v-if="shwTagsQuestion"
        @didClose="shwTagsQuestion = false"
        @confirmed="
          removeTags({ website_id: selectedTagsWebsiteId, tag: tagName })
        "
        @notConfirmed="shwTagsQuestion = false"
        title="Are you sure?"
        text="You will delete this tag."
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        isConfirmedTitle="Deleted!"
        isConfirmedText="Tag has been deleted!"
        dismissTitle="Cancelled!"
        dismissText="Tag is in the safe :)"
        confirmButtonClasses="btn btn-success"
        cancelButtonClasses="btn btn-danger"
        successIcon="success"
        errorIcon="error"
      />
      <!-- Edit domain's tags -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <div class="overlay" v-if="shwTagsEditingBlock">
          <div
            class="position-fixed code-block center py-15 px-6"
            style="
              background: #fff;
              top: 50% !important;
              border-radius: 4px;
              width: 300px !important;
            "
          >
            <em
              class="position-absolute"
              style="top: 10px; right: 18px; cursor: pointer"
              @click="shwTagsEditingBlock = !shwTagsEditingBlock"
              >&times;</em
            >
            <div class="py-6 px-6 mb-3"></div>
            <v-combobox
              v-model="selectedTagsForCreating"
              :items="allTags"
              item-text="name"
              item-value="name"
              multiple
              chips
              clearable
              deletable-chips
              solo
            >
            </v-combobox>
            <div class="d-flex justify-content-center">
              <button
                class="btn btn-primary mr-3"
                @click="
                  addTags({
                    website_id: selectedTagsWebsiteId,
                    array: selectedTagsForCreating,
                  }).finally(() => {
                    shwTagsEditingBlock = !shwTagsEditingBlock;
                  })
                "
              >
                Save
              </button>
              <button
                class="btn btn-info"
                @click="shwTagsEditingBlock = !shwTagsEditingBlock"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </transition>
    </section>

    <!-- Add New Pop Up -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <AddNewDomain
        v-if="shwAddNewDmnPopUp"
        @close="shwAddNewDmnPopUp = false"
      />
    </transition>

    <!-- Change Name Dialog -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <!-- <ChangeDmnName
        v-if="shwChangeDmnName"
        :url="url.split('://')[1]"
        :dmn_id="dmn_id"
      /> -->

      <dialog-window
        v-if="shwChangeDmnName"
        @closeDialogOutside="shwChangeDmnName = !shwChangeDmnName"
        @confirmed="changeDomainName($event)"
        :loading="processLoading"
        :entity="domainNameToChange"
      >
        <template #header> Change Domain Name </template>
        <template #disagreeBtnText> Cancel </template>
        <template #agreeBtnText> Change </template>
      </dialog-window>
    </transition>

    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Warnings v-if="warning" :warningText="warningText" />
    </transition>

    <!-- Success Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        :message="successMessage"
        @update-success="handleUpdateToSuccessSnackbar"
      />
    </transition>

    <!-- Failure Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        :message="failureMessage"
        @update-failure="handleUpdateToFailureSnackbar"
      />
    </transition>
  </div>
</template>

<script type="module">
import { mapState, mapActions, mapGetters } from "vuex";
import { BSpinner } from "bootstrap-vue";
//import Tags from "../../apis/Tags.js";
import Domains from "../../apis/Domains.js";
import Error from "../popUps/Error.vue";
import Question from "../popUps/Question.vue";
import Warnings from "../popUps/Warnings.vue";
import AddNewDomain from "../popUps/domains/AddNewDomain.vue";
import DialogWindow from "../popUps/DialogWindow.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";

import common from "../../mixins/common";
import "animate.css";

export default {
  name: "MainCont",
  mixins: [common],
  components: {
    Error,
    Warnings,
    Question,
    BSpinner,
    AddNewDomain,
    //ChangeDmnName,
    SuccessSnackbar,
    FailureSnackbar,
    DialogWindow,
  },
  data() {
    return {
      icon: "",
      tagColors: [
        "#88ACDF33",
        "#52A45133",
        "#F6C34433",
        "#C754E433",
        "#E45B5433",
      ],
      allTagsForCreating: [],
      selectedTagsForCreating: [],
      allTagsForSearching: [],
      selectedTagsForSearching: [],
      selectedTagsWebsiteId: null,
      tagName: "",
      failure: false,
      success: false,
      successMessage: "",
      failureMessage: "",
      processLoading: false,
      shwQuestion: false,
      shwTagsQuestion: false,
      shwChangeDmnName: false,
      shwAddNewDmnPopUp: false,
      shwTagsEditingBlock: false,
      domainNameToChange: "",
      searchTag: "",
      loading: true,
      offset: 0,
      search: "",
      dmnId: null,
      dmn_id: null,
      tagsLoading: false,
      warning: false,
      warningText: "",
    };
  },
  mounted() {
    let headers = this.isModerRole
      ? { Accept: "application/json", client: this.$route.params.client_uid }
      : { Accept: "application/json" };

    if (this.isModerRole) {
      this.loading = true;
    }

    if (!this.domains.length || this.isModerRole) {
      if (this.isUserRole || this.isModerRole) {
        this.getClientDomains(headers).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 0);
        });
      } else if (!this.isUserRole) {
        this.show().finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 0);
        });

        this.showTags();

        window.addEventListener("popstate", () => {
          this.$store.state.segment.segments = [];
        });
      }
    } else {
      this.loading = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("popstate", () => {});
  },
  computed: {
    ...mapState({
      domains: (state) => state.domain.domains,
      tags: (state) => state.tags.tags,
      error: (state) => state.domain.errorDomain,
    }),
    ...mapGetters(["roles"]),
    isUserRole() {
      return this.roles?.includes("user");
    },
    isModerRole() {
      return this.roles?.includes("moder");
    },
    filteredDomains() {
      return this.domains.filter((p) => {
        return (
          (p.url && p.url.toLowerCase()?.includes(this.search.toLowerCase())) ||
          (p.description &&
            p.description.toLowerCase()?.includes(this.search.toLowerCase())) ||
          p.id == this.search ||
          p.website_id == this.search
        );
      });
    },
    filteredTags() {
      return this.tags.filter((p) => {
        return p.name?.includes(this.searchTag);
      });
    },
    websiteDefaultImage() {
      return require("@/assets/website_icon.png");
    },
  },
  methods: {
    ...mapActions([
      "show",
      "delete",
      "update",
      "showTags",
      "addTags",
      "removeTags",
      "resetDomains"
    ]),

    getClientDomains(headers) {
      return new Promise((resolve, reject) => {
        Domains.getClientDomains(headers)
          .then((response) => {
            resolve(response);

            this.$store.state.domain.domains = response.data.data;
          })
          .catch((error) => {
            reject(error);

            this.failureMessage = error;
            this.failure = true;
          });
      });
    },
    updateDomainDescription(id, obj) {
      document.body.style.cursor = "wait";

      setTimeout(() => {
        document.body.style.cursor = "default";
      }, 1000);

      obj.fcm_conf = "client";

      this.update({
        id: id,
        json: obj,
      }).then(() => {
        this.successMessage = `Domain description has been changed successfully!`;
        this.success = true;
      });
    },
    changeDomainName(event) {
      if (!this.changeDomainName) {
        this.failureMessage = 'Domain name is required!';
        this.failure = true;

        return false;
      }
      if (event) {
        this.processLoading = true;

        setTimeout(() => {
          this.processLoading = false;
          this.shwChangeDmnName = false;
        }, 2000);

        Domains.update(this.dmn_id, {
          url: event,
          fcm_conf: "client",
        })
          .then(() => {
            this.show();

            this.success = true;
            this.successMessage = "Updated successfully!";
          })
          .catch((err) => {
            this.failure = true;
            this.failureMessage = "Fail to update!";

            this.error = err.response.message;
          });
      }
    },
    checkRestrictions() {
      if (this.roles?.includes("admin_trial") && this.domains.length === 3) {
        this.warningText = "You cannot add more than 3 domain due your plan.";
        this.warning = true;
      }
    },
    async bindTagToDomain(el, website_id, tag_name, tag_type) {
      this.$refs[el] !== undefined
        ? this.$refs[el][0].classList.add("loading")
        : null;

      this.selectedTagsForCreating = [];
      this.selectedTagsForCreating.push({
        id: website_id,
        name: tag_name,
        type: tag_type,
      });

      await this.addTags({
        website_id: website_id,
        array: this.selectedTagsForCreating,
      });

      setTimeout(() => {
        this.$refs[el][0].classList.remove("loading");
        this.successMessage = "Tag has been bound to the domain successfully!";
        this.success = true;
      }, 1000);
    },
    deleteDomain() {
      if (this.dmnId) {
        this.delete(this.dmnId);
      }
    },
    openWarningPopUp(event) {
      event.stopPropagation();
      this.shwQuestion = true;

      this.dmnId = event.target.closest(".col-xl-4.col-md-6.pt-1").id;
    },
  },
  watch: {
    selectedTagsForSearching(array) {
      if (!array.length) {
        this.show();
      } else {
        let params = array.map((el) => "tags[]=" + el.name).join("&");

        Domains.searchByTags("?" + params).then((response) => {
          this.$store.state.domain.domains = response.data.data;
        });
      }
    },
    '$route.name': {
      handler() {
        this.resetDomains();
      }, 
      deep: true,
      immediate: true
    },
    error() {
      if (this.error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
[v-cloak] {
  display: none !important;
}
.card.loading .card-body > .spinner-border {
  display: block !important;
}
.height-100vh {
  height: 100vh !important;
}
.content {
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
}
.content p {
  margin: 1em 0;
  padding: 0 0 2em;
  font-size: 0.85em;
}
</style>
